<template>
  <svg :class="mailActiveClass" class="mailActive-icon" :width="width" :height="height" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="nonzero" d="m8.278 7.806 3.777 3.262 3.563-3.088L23.373 16H.6l7.677-8.194ZM0 15.321V.605l7.606 6.62L0 15.321Zm16.29-7.922L24 .659v14.653l-7.71-7.913ZM23.587 0 12.054 9.89.484 0h23.104Z" /></svg>
</template>

<script>
export default {
  name: 'MailActive',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    width: {
      type: [Number, String],
      default: 25,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
  computed: {
    mailActiveClass() {
      return {
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
      };
    },
  },
};

</script>

<style lang="scss" scopped>
  .mailActive-icon {
    display: block;
    width: 23px;
    height: 18px;
  }
</style>
